<template>
  <div>
    <left-sidebar :ppa="ppa" />
    <right-sidebar :ppa="ppa" />
    <header-bp
      :user="user"
      :ppa="ppa"
    />
    <div class="header-spacer" />
    <div class="container">
      <div class="row">
        <div class="col col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
          <div class="ui-block responsive-flex">
            <course-form />
            <div class="ui-block-title">
              <div class="h6 title">
                Tickets
              </div>
              <div class="align-right">
                <form class="w-search">
                  <div class="form-group with-button">
                    <input
                      v-model="term"
                      class="form-control"
                      type="text"
                      :placeholder="searchText"
                    >

                    <button @click.stop.prevent="search1">
                      <svg
                        viewBox="0 0 24 24"
                        width="24"
                        height="24"
                        role="presentation"
                        class="sprite-icon olymp-magnifying-glass-icon"
                      >
                        <use
                          xmlns:xlink="http://www.w3.org/1999/xlink"
                          xlink:href="../../../static/sprites/icons.svg#olymp-magnifying-glass-icon"
                        />
                      </svg>
                    </button>
                  </div>
                </form>
                <a
                  href=""
                  @click.stop.prevent="changeType"
                >Change</a> {{ searchType }}
                <a
                  href="#"
                  class="btn btn-primary btn-md"
                  @click="$modal.show('course-form', {item: {title:'', trainer: '', rank:0, date_begin: new Date(), date_end: new Date() }})"
                >Create Course +</a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        v-if="courses && courses.length"
        class="row"
      >
        <div
          v-for="item in courses"
          :key="item.id"
          class="col-xl-4 col-lg-6 col-md-12 col-sm-12 col-xs-12"
        >
          <div class="ui-block">
            <!-- Birthday Item-->
            <div class="birthday-item inline-items">
              <div class="author-thumb">
                <img
                  src="../../../static/img/avatar2-sm.jpg"
                  alt="author"
                >
              </div>
              <div class="birthday-author-name">
                <label class="h6 author-name">
                  <router-link
                    :to="{ path: '/courses/' + item.id }"
                    class="h3 post-title"
                  >
                    {{ item.title }}
                  </router-link>
                </label>
              </div>
            </div>

            <!-- ... end Birthday Item-->
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
          <!-- Pagination -->
          <pagination
            v-model="currentPage"
            :records="totalCourses"
            :per-page="perpage"
            @paginate="paginationChange"
          />
          <!-- ... end Pagination -->
        </div>
      </div>
    </div>
    <a
      href="#"
      class="back-to-top"
    >
      <app-icon
        name="olymp-stats-arrow-icon"
        tooltip="Back to top"
        color="white"
        size="medium"
      />
    </a>
  </div>
</template>

<script>

import { mapState } from 'vuex'
import LeftSidebar from '../../components/common-apps/common/LeftSidebar'
import RightSidebar from '../../components/common-apps/common/RightSidebar'
import HeaderBp from '../../components/common-apps/common/HeaderBp'
import AppIcon from "../../components/common-apps/common/AppIcon";
import courseStore from '../../store/modules/spiritual/course'
import CourseForm from "../../components/spiritual/course/CourseForm"
import Pagination from 'vue-pagination-2'
// import {format} from "date-fns";

export default {
  name: 'TicketList',
  components: {
    LeftSidebar,
    RightSidebar,
    HeaderBp,
    AppIcon,
    CourseForm,
    Pagination
  },
  data () {
    return {
      term: '',
      searchText: 'Search courses by tag...',
      searchType: 'tag',
      currentPage: 1,
      perpage: 15,
    }
  },
  computed: mapState({
    courses: state => state.course ? state.course.items : [],
    totalCourses: state => state.course? state.course.totalItems : 0,
    ppa: state => state.account.ppa,
    user () {
      return !this.$store.getters['account/user'] ? { username: 'None' } : this.$store.getters['account/user']
    }
  }),
  created () {
    this.$store.dispatch('account/fetchUser')
    if (!this.$store.hasModule('course')) {
      this.$store.registerModule('course', courseStore)
    }
    if (this.$route.params.type) {
      this.searchType = this.$route.params.type
      this.term = decodeURI(this.$route.params.term)
      let opts = { currentPage: 1, perpage: this.perpage, term: this.term, searchType: this.searchType }
      this.$store.dispatch('course/search', opts)
    }  else {
      this.$store.dispatch('course/getCourses', {currentPage: 1, perpage: this.perpage})
    }
  },
  beforeDestroy () {
    this.$store.unregisterModule('course')
  },
  methods: {
    paginationChange (currentPage) {
      // eslint-disable-next-line
      let opts = { currentPage, perpage: this.perpage }
      this.$store.dispatch('course/getCourses', opts);
    },
    search1 () {
      let aa = encodeURI(this.term);
      this.$router.push(`/${this.ppa}/course/search/${this.searchType}/${aa}`)
    },
    changeType () {
      if (this.searchType === 'tag') {
        this.searchType = 'title'
      } else {
        this.searchType = 'tag'
      }
      this.searchText = `Search courses by ${this.searchType}...`
    }
  }
}
</script>

<style lang="scss">
// Bootstrap from node_modules has container smaller
@import '../../scss/Bootstrap/scss/bootstrap-reboot';
@import '../../scss/Bootstrap/scss/bootstrap';
@import '../../scss/Bootstrap/scss/bootstrap-grid';

@import '../../scss/ticket2';
// @import '../../scss/fonts';

/* required class */
.my-editor {
  /* we dont use `language-` classes anymore so thats why we need to add background and text color manually */
  background: #2d2d2d;
  color: #ccc;

  /* you must provide font-family font-size line-height. Example: */
  font-family: Fira code, Fira Mono, Consolas, Menlo, Courier, monospace;
  font-size: 18px;
  line-height: 1.5;
  padding: 5px;
}

/* optional class for removing the outline */
.prism-editor__textarea:focus {
  outline: none;
}

</style>
